import { TID } from "@/constants/testIds";
import { TreePine } from "lucide-react";
import { fmt, KPI } from "./_shared";

export function HabitatTab({ rows, overview }) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <KPI label="Hectares Managed"  value={fmt(overview.habitat.hectares_managed, 1)} icon={TreePine} tone="good" />
        <KPI label="Sites"             value={fmt(overview.habitat.sites_count)} />
        <KPI label="Native Species"    value={fmt(rows.reduce((s, r) => s + (r.native_species_count || 0), 0))} tone="good" />
      </div>
      <div className="rounded-lg border border-slate-200 bg-white overflow-x-auto">
        <div className="grid grid-cols-5 gap-2 min-w-[560px] px-4 py-2.5 text-[11px] uppercase tracking-wider text-white bg-emerald-800">
          <div>Site</div>
          <div className="text-right">Hectares</div>
          <div className="text-right">Native Species</div>
          <div className="text-right">Planting Events</div>
          <div>Note</div>
        </div>
        <div className="divide-y divide-slate-100">
          {rows.length === 0 && (
            <div className="px-4 py-8 text-sm text-slate-500 text-center" data-testid="habitat-empty">
              No habitat or biodiversity programs recorded yet. Entries can be added via the sustainability
              API as site programs (wetland rehab, plantings, nest boxes) commence.
            </div>
          )}
          {rows.map((r) => (
            <div key={r.id} data-testid={TID.sustHabitatRow(r.id)} className="grid grid-cols-5 gap-2 min-w-[560px] px-4 py-3 text-sm items-center">
              <div className="text-slate-900 font-medium">{r.site}</div>
              <div className="text-right text-slate-700">{fmt(r.hectares_managed, 1)} ha</div>
              <div className="text-right text-emerald-700 font-semibold">{r.native_species_count}</div>
              <div className="text-right text-slate-700">{r.planting_events_ytd}</div>
              <div className="text-xs text-slate-500 truncate">{r.note}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
